<template>
    <input class="th w-100 pl2 ba b--light-gray" :type="type" :placeholder="placeholder" :value="value" v-on="inputListeners" v-focus.lazy="focused && lg"/>
</template>

<script>
import { focus } from 'vue-focus';

export default {
    directives: { focus: focus },
    props: {
        placeholder: {
            type: String,
            required: false
        },
        value: {
            type: String
        },
        focused: {
            type: Boolean
        },
        type: {
            type: String,
            default: 'text'
        }
    },
    methods: {
        update(value) {
            this.$emit('input', value);
        }
    },
    computed: {
        inputListeners: function() {
            var vm = this;
            return Object.assign({}, this.$listeners, {
                input: function(event) {
                    vm.$emit('input', event.target.value);
                }
            });
        },
        lg() {
            return this.$mq === 'lg';
        }
    }
};
</script>
